(function() {
  // Detecta si es escritorio (no táctil y ancho mínimo 1025px)
  const isDesktop = window.matchMedia("(min-width: 1025px)").matches && !('ontouchstart' in window);

  if (!isDesktop) {
    return; // en móviles/tablets no aplica
  }

  const scrollSpeed = 0.1; // Ajusta la suavidad (más pequeño = más lento)
  let scrollTarget = window.scrollY;
  let scrollPosition = window.scrollY;

  function smoothScroll() {
    scrollPosition += (scrollTarget - scrollPosition) * scrollSpeed;
    window.scrollTo(0, scrollPosition);
    requestAnimationFrame(smoothScroll);
  }

  window.addEventListener("wheel", function(e) {
    e.preventDefault();
    scrollTarget += e.deltaY;
    scrollTarget = Math.max(0, scrollTarget); 
    scrollTarget = Math.min(document.body.scrollHeight, scrollTarget);
  }, { passive: false });

  smoothScroll();
})();
